import { OFFERWALL_URL } from '../constants';
import { createDebugLogger } from './debug';
const debug = createDebugLogger('offerwallUrl');
/**
 * Builds the perkswall offerwall URL from SDK / user payload (shared by OfferwallCTA and COU).
 */
export function buildOfferwallUrl(payload) {
    const queryStrings = [];
    const accountIdentifier = payload.awinAdvertiserId ||
        payload.accountId;
    if (!accountIdentifier) {
        debug.error('Missing accountId or awinAdvertiserId in payload');
        return '';
    }
    if (payload.awinAdvertiserId) {
        queryStrings.push(`awinAdvertiserId=${encodeURIComponent(String(payload.awinAdvertiserId))}`);
    }
    else {
        queryStrings.push(`accountId=${encodeURIComponent(String(payload.accountId))}`);
    }
    for (const key in payload) {
        if (!Object.prototype.hasOwnProperty.call(payload, key)) {
            continue;
        }
        const val = payload[key];
        if (typeof val === 'undefined' || val === '' || val === null) {
            continue;
        }
        if ([
            'accountId',
            'awinAdvertiserId',
            'campaignId',
            'dev',
            'offerId',
            'settings',
            'styles',
            'sessionId',
        ].includes(key)) {
            continue;
        }
        queryStrings.push(`${key}=${encodeURIComponent(String(val))}`);
    }
    const queryStringPayload = queryStrings.join('&');
    return `${OFFERWALL_URL}?${queryStringPayload}`;
}
